export const WEB_SDK_TESTS_PAGE_MAIN_TITLE_ID = 'web-sdk-tests-page-main-title';
export const WEB_SDK_TESTS_PAGE_FILTERS_SECTION_ID = 'web-sdk-tests-page-filters-section';
export const SHOW_ONLY_LATEST_TESTS_TOGGLE_ID = 'show-only-latest-tests-toggle';
export const WEB_SDK_TESTS_PAGE_USAGE_SECTION_ID = 'web-sdk-tests-page-usage-section';
export const WEB_SDK_TESTS_PAGE_USAGE_TITLE_ID = 'web-sdk-tests-page-usage-title';
export const WEB_SDK_TESTS_PAGE_TABLE_SECTION_ID = 'web-sdk-tests-page-table-section';
export const WEB_SDK_TESTS_PAGE_TABLE_TITLE_ID = 'web-sdk-tests-page-table-title';
